import { Lock, Sparkles } from "lucide-react";

export const EmailBetaOverlay = ({ testId = "email-beta-overlay" }) => (
  <div
    className="absolute inset-0 z-20 flex items-center justify-center rounded-b-xl bg-white/78 px-4 py-8 backdrop-blur-sm"
    data-testid={testId}
  >
    <div className="max-w-md rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-2xl">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#42D78A]/15 text-[#157347]">
        <Sparkles className="h-7 w-7" />
      </div>
      <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#42D78A]">Coming Soon</p>
      <h3 className="mt-2 text-2xl font-bold text-[#1a1a1a]" style={{ fontFamily: "'Outfit', sans-serif" }}>
        Email List/Messages is in beta
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        This feature is currently being beta tested and is open to a select few users.
      </p>
      <p className="mt-3 text-sm leading-relaxed text-slate-600">
        Want to be a beta tester? Send us an email at{" "}
        <a href="mailto:hello@614shoplocal.com" className="font-bold text-blue-600 underline underline-offset-2">
          hello@614shoplocal.com
        </a>.
      </p>
      <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-slate-100 px-4 py-2 text-xs font-bold text-slate-600">
        <Lock className="h-3.5 w-3.5" />
        Access locked for now
      </div>
    </div>
  </div>
);
